import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initSentry } from './lib/sentry';
import { initAxiom } from './lib/axiom';

// Inicializar Sentry
initSentry();

// Inicializar Axiom
initAxiom();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
